import { defineComponent } from '@vue/composition-api';
export default defineComponent({
  setup() {
    const themeVars = {
      buttonPrimaryBackground: '#f68657',
      buttonPrimaryBorderColor: '#f68657',
      fieldLabelColor: '#323233',
      cellGroupTitleColor: '#f68657',
      cellGroupTitleFontSize: '16px',
      cellFontSize: '16px',
      cellLabelFontSize: '14px',
      navBarIconColor: '#f68657',
      stepFontSize: '12px',
      fieldLabelWidth: '7em'
    };
    return {
      themeVars
    };
  }
});